/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerListProjectSightProjectsQueryResponse, TrimbleItemsControllerListProjectSightProjectsQueryParams } from "../../models/trimbleController/TrimbleItemsControllerListProjectSightProjects";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleItemsControllerListProjectSightProjects } from "../../clients/trimbleService/trimbleItemsControllerListProjectSightProjects";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleItemsControllerListProjectSightProjectsQueryKey = (params: TrimbleItemsControllerListProjectSightProjectsQueryParams) => [{
  url: '/api/v1/trimble/projectsight/projects'
}, ...(params ? [params] : [])] as const;
export type TrimbleItemsControllerListProjectSightProjectsQueryKey = ReturnType<typeof trimbleItemsControllerListProjectSightProjectsQueryKey>;
export function trimbleItemsControllerListProjectSightProjectsQueryOptions(params: TrimbleItemsControllerListProjectSightProjectsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleItemsControllerListProjectSightProjectsQueryKey(params);
  return queryOptions<TrimbleItemsControllerListProjectSightProjectsQueryResponse, ResponseErrorConfig<Error>, TrimbleItemsControllerListProjectSightProjectsQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleItemsControllerListProjectSightProjects(params, config);
    }
  });
}

/**
 * @summary List the caller's ProjectSight projects with service-credential access status
 * {@link /api/v1/trimble/projectsight/projects}
 */
export function useTrimbleItemsControllerListProjectSightProjects<TData = TrimbleItemsControllerListProjectSightProjectsQueryResponse, TQueryData = TrimbleItemsControllerListProjectSightProjectsQueryResponse, TQueryKey extends QueryKey = TrimbleItemsControllerListProjectSightProjectsQueryKey>(params: TrimbleItemsControllerListProjectSightProjectsQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleItemsControllerListProjectSightProjectsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleItemsControllerListProjectSightProjectsQueryKey(params);
  const query = useQuery({
    ...trimbleItemsControllerListProjectSightProjectsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}